<template>
    <div class="ui-loading"></div>
</template>

<script>
export default {
  name: 'loading'
}
</script>

<style scoped>
.ui-loading {
  width: 100%;
  height: 100%;
  background: url('./images/loading.gif') no-repeat center;
  background-size: auto 70%;
}
</style>


